import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../services/apis";
import { Button, Dropdown } from "semantic-ui-react";
import { Container } from "./styles";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { AlunoSearchInput } from "../../../components/Admin/AlunoSearchInput";

export const MBARemover = props => {
  const [selectedAluno, setSelectedAluno] = useState(null);
  const [selectedMBA, setSelectedMBA] = useState(null);

  const [mbas, setMbas] = useState([]);

  useEffect(() => {
    if (!selectedAluno) return;
    api
      .get(`/admin/mba/list-from-aluno/${selectedAluno}`)
      .then(response => setMbas(response.data));
  }, [selectedAluno]);

  const handleSubmit = async () => {
    if (!selectedAluno || !selectedMBA) {
      swal("Por favor, preencha os dois campos", "", "error");
      return;
    }

    try {
      api
        .delete(`/admin/mba/remove-live/${selectedAluno}/${selectedMBA}`)
        .then(async () => {
          swal("MBA removido", "", "success").then(() => location.reload());

          const logs = {
            local: "/admin/mba/remover",
            texto: `Removeu o MBA (${selectedMBA}) do aluno (${selectedAluno})`,
          };
          await api.post("system_logs", {
            acao: JSON.stringify(logs),
          });
        });
    } catch (error) {
      swal("Houve um erro ao liberar o MBA", "", "error").then(() =>
        location.reload()
      );
      const logs = {
        local: "/admin/mba/remover",
        texto: `Tentou remover o MBA (${selectedMBA}) do aluno (${selectedAluno}) - Erro: ${error}`,
      };
      await api.post("system_logs", {
        acao: JSON.stringify(logs),
      });
    }
  };

  return (
    <div style={{width:"100vw", paddingLeft:"250px"}}>
      <AdminMenu />
      <Container>
        <h1>Remover MBA</h1>

        <form>
          <AlunoSearchInput
            handleChange={evt => {
              setSelectedAluno(evt.id);
            }}
          />

          {mbas && (
            <Dropdown
              placeholder="Selecione um MBA"
              selection
              options={mbas.map(mba => ({
                key: mba.id,
                text: mba.descricao,
                value: mba.id_curso,
              }))}
              onChange={(event, data) => {
                setSelectedMBA(data.value);
              }}
            />
          )}
        </form>
        <Button onClick={() => handleSubmit()}>Remover</Button>
      </Container>
    </div>
  );
};
